export const ERROR_MESSAGES: Record<string, string> = {
  required: 'errorMessages.required',
  minlength: 'errorMessages.minlength',
  maxlength: 'errorMessages.maxlength',
  email: 'errorMessages.email',
  mrnFormat: 'errorMessages.mrn-format',
  mrnLength: 'errorMessages.mrn-length',
  mrnPlaceholder: 'errorMessages.mrn-placeholder',
};
